import React from 'react';
import { Dialog, DialogContent, DialogTitle, DialogActions, Box, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DataTable from 'components/utils/DataTable';
import DateTimeHelpers from 'helpers/DateTimeHelpers';
import { useTranslation } from 'react-i18next';

export default function ExternalSyncFailedSaleDialog({ open, log, onClose, onRetry }) {
  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');

  const onClickRetry = async () => {
    onClose();
    await onRetry(log.sale_id);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between">
          {tPopup('Sale Sync Error Details')}
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box mb={2}>
          {tCommon('Sale ID')}: {log?.sale_id}{' '}
        </Box>
        <DataTable
          columns={[
            {
              id: 'date',
              label: tCommon('Date'),
              type: 'callback',
              viewRender: (data) => DateTimeHelpers.getTime(data.created_at),
            },
            {
              id: 'time',
              label: tCommon('Time'),
              type: 'callback',
              viewRender: (data) => DateTimeHelpers.getTime(data.created_at),
            },
            { id: 'message', label: tPopup('Error Message'), type: 'text' },
          ]}
          rows={log?.logs || []}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" onClick={onClose}>
          {tCommon('Close')}
        </Button>
        <Button variant="contained" color="primary" onClick={onClickRetry}>
          {tCommon('Retry')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
